 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"lang-zh-HK-js":"lang-zh-HK-js"}[chunkId]||chunkId) + "." + {"chunk-9ebbde30":"6d2962af","lang-zh-HK-js":"f5d6ec34","chunk-0b65ffb6":"4cc6cbed","chunk-2d0a3577":"5c370725","chunk-2d0a43df":"49642bba","chunk-2d0aa90c":"cd1519b9","chunk-2d0aab07":"3a3dba34","chunk-2d0abc00":"c4aeebf3","chunk-2d0ae937":"9b978668","chunk-2d0aeb45":"09cafab5","chunk-2d0af08c":"be30efc8","chunk-2d0afa49":"e9d1edd0","chunk-2d0b2762":"4ccb83f0","chunk-2d0b6187":"fea81e83","chunk-2d0ba136":"cdc20342","chunk-2d0bb267":"5de02936","chunk-2d0bcec1":"f09cc75b","chunk-2d0bdf38":"efd43334","chunk-2d0bff92":"e5d5efbc","chunk-2d0c0494":"f6ec8c16","chunk-2d0c0a09":"a067e551","chunk-2d0c4313":"3b38ebcc","chunk-2d0c46d1":"47c50e75","chunk-2d0c512b":"e873bd47","chunk-2d0cf16e":"e68e5cc3","chunk-2d0d056d":"26900b7c","chunk-2d0d0645":"a59b5523","chunk-2d0d2f22":"671b60c0","chunk-2d0d61fd":"81852c50","chunk-2d0d7e63":"13ddd402","chunk-2d0e1b57":"e720f971","chunk-2d0e1fbe":"2900e6b0","chunk-2d0e22d6":"7e8fce1e","chunk-2d0e542a":"5aad21b2","chunk-2d0e57ec":"fe5b8492","chunk-2d0e6553":"cd919002","chunk-2d0e6c86":"5d3c34c1","chunk-2d0ea098":"16551036","chunk-2d0f0a11":"a145582e","chunk-2d208ac5":"45015686","chunk-2d209408":"c71f6f43","chunk-2d20f745":"82477bfe","chunk-2d20ff23":"0db7deea","chunk-2d2138c7":"38324c1e","chunk-2d216f3b":"d2210c51","chunk-2d217e5b":"4bcef4b7","chunk-2d21b84a":"cdf28761","chunk-2d21dcd2":"9ba0f5d2","chunk-2d21f327":"1d87bdee","chunk-2d2214b3":"5d7e6500","chunk-2d221799":"c37bd00e","chunk-2d221814":"d4f70c12","chunk-2d221a34":"83463dce","chunk-2d22502a":"c6da651b","chunk-2d226775":"58826065","chunk-2d229411":"af9d37ff","chunk-2d2295e9":"cf94dd88","chunk-2d22c171":"64d07829","chunk-2d22c2b8":"60ce0ab4","chunk-2d22ca58":"c3776251","chunk-2d2311f7":"1e74a811","chunk-2d237ee7":"a00e5e1f","chunk-2d238465":"80d9b945","chunk-30597b4a":"fe12185b","chunk-7532b3ea":"ee52a302","chunk-e13e4362":"5806dd89"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-9ebbde30":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"lang-zh-HK-js":"lang-zh-HK-js"}[chunkId]||chunkId) + "." + {"chunk-9ebbde30":"a2ff0e3b","lang-zh-HK-js":"31d6cfe0","chunk-0b65ffb6":"31d6cfe0","chunk-2d0a3577":"31d6cfe0","chunk-2d0a43df":"31d6cfe0","chunk-2d0aa90c":"31d6cfe0","chunk-2d0aab07":"31d6cfe0","chunk-2d0abc00":"31d6cfe0","chunk-2d0ae937":"31d6cfe0","chunk-2d0aeb45":"31d6cfe0","chunk-2d0af08c":"31d6cfe0","chunk-2d0afa49":"31d6cfe0","chunk-2d0b2762":"31d6cfe0","chunk-2d0b6187":"31d6cfe0","chunk-2d0ba136":"31d6cfe0","chunk-2d0bb267":"31d6cfe0","chunk-2d0bcec1":"31d6cfe0","chunk-2d0bdf38":"31d6cfe0","chunk-2d0bff92":"31d6cfe0","chunk-2d0c0494":"31d6cfe0","chunk-2d0c0a09":"31d6cfe0","chunk-2d0c4313":"31d6cfe0","chunk-2d0c46d1":"31d6cfe0","chunk-2d0c512b":"31d6cfe0","chunk-2d0cf16e":"31d6cfe0","chunk-2d0d056d":"31d6cfe0","chunk-2d0d0645":"31d6cfe0","chunk-2d0d2f22":"31d6cfe0","chunk-2d0d61fd":"31d6cfe0","chunk-2d0d7e63":"31d6cfe0","chunk-2d0e1b57":"31d6cfe0","chunk-2d0e1fbe":"31d6cfe0","chunk-2d0e22d6":"31d6cfe0","chunk-2d0e542a":"31d6cfe0","chunk-2d0e57ec":"31d6cfe0","chunk-2d0e6553":"31d6cfe0","chunk-2d0e6c86":"31d6cfe0","chunk-2d0ea098":"31d6cfe0","chunk-2d0f0a11":"31d6cfe0","chunk-2d208ac5":"31d6cfe0","chunk-2d209408":"31d6cfe0","chunk-2d20f745":"31d6cfe0","chunk-2d20ff23":"31d6cfe0","chunk-2d2138c7":"31d6cfe0","chunk-2d216f3b":"31d6cfe0","chunk-2d217e5b":"31d6cfe0","chunk-2d21b84a":"31d6cfe0","chunk-2d21dcd2":"31d6cfe0","chunk-2d21f327":"31d6cfe0","chunk-2d2214b3":"31d6cfe0","chunk-2d221799":"31d6cfe0","chunk-2d221814":"31d6cfe0","chunk-2d221a34":"31d6cfe0","chunk-2d22502a":"31d6cfe0","chunk-2d226775":"31d6cfe0","chunk-2d229411":"31d6cfe0","chunk-2d2295e9":"31d6cfe0","chunk-2d22c171":"31d6cfe0","chunk-2d22c2b8":"31d6cfe0","chunk-2d22ca58":"31d6cfe0","chunk-2d2311f7":"31d6cfe0","chunk-2d237ee7":"31d6cfe0","chunk-2d238465":"31d6cfe0","chunk-30597b4a":"31d6cfe0","chunk-7532b3ea":"31d6cfe0","chunk-e13e4362":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([1,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
